// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let WizardUploads = require("../wizard/WizardUploads.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardUploads_draft_graphql = require("../../../__generated__/PropertyWizardUploads_draft_graphql.bs.js");

let convertFragment = PropertyWizardUploads_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardUploads_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardUploads_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardUploads_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardUploads_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardUploads(props) {
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardUploads_draft_graphql.node, convertFragment, props.draft);
  let updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  let updateFormState = PropertyWizardFormRelay.FormState.useUpdater();
  let initialImages = draft.draftProperty.images.map(image => WizardUploads.makeImageAttachment(image.id, image.key, image.fileName, image.contentType, image.previewUrl));
  let initialFiles = draft.draftProperty.files.map(file => WizardUploads.makeFileAttachment(file.id, file.key, file.fileName, file.contentType));
  let updateImages = images => {
    let images$1 = Stdlib_List.toArray(images);
    let imagesReadyToSave = WizardUploads.imagesReadyToSave(images$1);
    updateDraftProperty(localDraftProperty => {
      let newrecord = {...localDraftProperty};
      newrecord.images = imagesReadyToSave.map(param => {
        let attachment = param[1];
        return {
          contentType: attachment.contentType,
          fileName: attachment.fileName,
          id: attachment.id,
          key: attachment.key,
          previewUrl: param[0]
        };
      });
      return newrecord;
    });
    updateFormState(formState => {
      formState.imagesStatus = WizardUploads.getAttachmentStatuses("Failed", "InProgress", images$1);
    });
  };
  let updateFiles = files => {
    let files$1 = Stdlib_List.toArray(files);
    let filesReadyToSave = WizardUploads.filesReadyToSave(files$1);
    updateDraftProperty(localDraftProperty => {
      let newrecord = {...localDraftProperty};
      newrecord.files = filesReadyToSave.map(attachment => ({
        contentType: attachment.contentType,
        fileName: attachment.fileName,
        id: attachment.id,
        key: attachment.key
      }));
      return newrecord;
    });
    updateFormState(formState => {
      formState.filesStatus = WizardUploads.getAttachmentStatuses("Failed", "InProgress", files$1);
    });
  };
  return JsxRuntime.jsx(WizardUploads.make, {
    serverDraftId: draft.serverDraftId,
    initialImages: initialImages,
    initialFiles: initialFiles,
    updateImages: updateImages,
    updateFiles: updateFiles,
    render: props.render
  });
}

let make = PropertyWizardUploads;

exports.DraftFragment = DraftFragment;
exports.make = make;
/* WizardUploads Not a pure module */
